module.exports = __webpack_public_path__ + "img/no-img.acbf5e6.png";